import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvService } from 'src/app/env-service/env.service';
import { environment } from 'src/environments/environment';
import { Group } from '../model/group';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(private http: HttpClient, private envService: EnvService) { }

  getGroupDataFor(policyNumber: number): Observable<Group> {
    const url = environment.getApiUrl(environment.groupUrl(policyNumber),
                                      this.envService.contractsApiEndpoint,
                                      this.envService.apiSubscriptionId);
    return this.http.get<Group>(url);
  }

}